import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import getBusinessName from "../../common/Business";

class BusinessNearby extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  state = {
    activeIndex: 0,
    rows: [],
  };

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const rows = [];
    if (props.node !== undefined) {
      const nearbyBusinesses = _.get(props.node, "nearby[0].nearbybusiness");
      if (nearbyBusinesses === undefined || nearbyBusinesses.lenght === 0) {
        rows.push(
          <Table.Row>
            <Table.Cell>No Nearby Businesses Found</Table.Cell>
          </Table.Row>
        );
      } else {
        _.forEach(nearbyBusinesses, (nearbyBusiness, index) => {
          const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
          rows.push(
            <Table.Row key={`Row_Business_Nearby_Name_${index}`}>
              <Table.Cell className={colorClass}>
                {getBusinessName(
                  _.get(nearbyBusiness, "nearbyCompanyName[0]._", ""),
                  props
                )}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Nearby_Address_${index}`}>
              <Table.Cell className={colorClass}>
                {_.get(nearbyBusiness, "nearbyAddress[0]._")}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Nearby_City_${index}`}>
              <Table.Cell className={colorClass}>{`${_.get(
                nearbyBusiness,
                "nearbyCity[0]._"
              )} ${_.get(nearbyBusiness, "nearbyState[0]._")} ${_.get(
                nearbyBusiness,
                "nearbyZip[0]._"
              )}`}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Nearby_Phone_${index}`}>
              <Table.Cell className={colorClass}>
                {_.get(nearbyBusiness, "nearbyPhone[0]._")}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Nearby_Type_${index}`}>
              <Table.Cell className={colorClass}>
                {`Type of business: ${_.get(
                  nearbyBusiness,
                  "nearbySIC01[0]._"
                )}`}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Nearby_Distance_${index}`}>
              <Table.Cell className={colorClass}>
                {`Distance (Miles): ${_.get(
                  nearbyBusiness,
                  "nearbyDistance[0]._"
                )}`}
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }
    this.state = { rows, activeIndex: 0 };
  };

  render() {
    return (
      <Accordion fluid styled key={`Business_Section_Nearby`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Business_Nearby_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Nearby Businesses
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Business_Nearby_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default BusinessNearby;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessNearby.js